/**
 * Do not edit directly, use `yarn generate:icons`
 */

import React from 'react';
import {Base} from '../../../Internal/Base/';

const pathStrings = {
  16: [
    'M8 0c3.552 0 6.5 2.948 6.5 6.5 0 3.291-4.213 9.5-6.5 9.5S1.5 9.791 1.5 6.5C1.5 2.948 4.448 0 8 0zm0 2C5.552 2 3.5 4.052 3.5 6.5 3.5 8.814 7.02 14 8 14s4.5-5.186 4.5-7.5C12.5 4.052 10.448 2 8 2zm0 2.6a2 2 0 11.001 3.999A2 2 0 018 4.6z',
  ],

  24: [
    'M12 2c4.552 0 8 3.448 8 8 0 1.075-.393 2.43-1.017 3.84l-.245.53-.13.266-.273.533-.143.266-.298.53-.312.525C15.78 19.44 13.397 22 12 22c-1.397 0-3.78-2.559-5.582-5.51l-.312-.525-.298-.53a23.393 23.393 0 01-.143-.266l-.273-.533a21.52 21.52 0 01-.13-.266l-.245-.53C4.394 12.43 4 11.074 4 10c0-4.552 3.448-8 8-8zm0 2c-3.448 0-6 2.552-6 6 0 1.567 1.084 4.018 2.759 6.43l.297.417.3.402.302.386.298.366.292.344.282.32.268.29.25.262.118.118.22.21.192.175c.209.18.358.28.422.28.055 0 .172-.073.336-.208l.179-.154.206-.193.113-.11.24-.245.26-.277.136-.149.282-.319.292-.344.298-.366.301-.386.301-.402.297-.417C16.916 14.018 18 11.567 18 10c0-3.448-2.552-6-6-6zm0 4a2 2 0 110 4 2 2 0 010-4z',
  ],
};

type Props = {size: keyof typeof pathStrings} & Omit<
  React.SVGAttributes<HTMLOrSVGElement>,
  'width' | 'height' | 'viewBox'
>;

export const IconPinOutline = ({
  size,
  className,
  ...rest
}: Props): React.ReactElement<React.ReactSVGElement> => {
  const paths = pathStrings[size].map((d: string, i: number) => (
    <path key={String(i)} d={d} fillRule="evenodd" />
  ));

  return (
    <Base
      as="svg"
      height={size}
      width={size}
      viewBox={`0 0 ${size} ${size}`}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      // Because viewPort(height + width) and viewBox might not have the same ratio
      // `preserveAspectRatio` indicates wether we should force a uniform scaling.
      // Therefore, `xMidYMid` centers the viewBox region within the viewPort region,
      // and `meet` scales the graphic until it meets the height and width of our viewPort.
      // More details here, https://www.digitalocean.com/community/tutorials/svg-preserve-aspect-ratio
      preserveAspectRatio="xMidYMid meet"
      fill="currentColor"
      {...rest}
    >
      {paths}
    </Base>
  );
};

IconPinOutline.displayName = 'IconPinOutline';
